/* ============================================================
   SANE ACTIVE — Shopify Theme JS
   Production-ready, no console.log, no unused code
   ============================================================ */

(function () {
  'use strict';

  /* ── Utility ─────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ── Format money ─────────────────────────────────────── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'CHF\u00a0' + amount;
  }

  /* ── Toast ─────────────────────────────────────────────── */
  var toast = qs('#toast');
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
  }

  /* ── Header scroll behaviour ──────────────────────────── */
  var header = qs('#site-header');
  var menuOpen = false;
  if (header) {
    var isTransparentPage = header.classList.contains('site-header--transparent');
    var isAutoHide = header.classList.contains('site-header--autohide');
    var lastScrollY = window.scrollY;

    function onScroll() {
      var scrollY = window.scrollY;
      if (scrollY > 50) {
        header.classList.add('site-header--scrolled');
      } else {
        if (!menuOpen) header.classList.remove('site-header--scrolled');
      }
      if (isAutoHide && !menuOpen) {
        if (scrollY > lastScrollY && scrollY > 120) {
          header.classList.add('site-header--hidden');
        } else {
          header.classList.remove('site-header--hidden');
        }
      }
      lastScrollY = scrollY;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Menu ──────────────────────────────────────── */
  var mobileMenu = qs('#mobile-menu');
  var mobileMenuBtn = qs('.mobile-menu-btn');
  var mobileMenuBackdrop = qs('#mobile-menu-backdrop');
  var menuIconOpen = qs('.menu-icon-open');
  var menuIconClose = qs('.menu-icon-close');

  function openMenu() {
    menuOpen = true;
    if (mobileMenu) {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
    }
    if (header) header.classList.add('site-header--scrolled');
    document.body.style.overflow = 'hidden';
    if (mobileMenuBtn) {
      mobileMenuBtn.setAttribute('aria-expanded', 'true');
      mobileMenuBtn.setAttribute('aria-label', 'Menu schliessen');
    }
    if (menuIconOpen) menuIconOpen.style.display = 'none';
    if (menuIconClose) menuIconClose.style.display = 'block';
    /* Stagger nav links */
    qsa('.mobile-menu-link', mobileMenu).forEach(function (link, i) {
      link.style.transitionDelay = (150 + i * 50) + 'ms';
    });
  }

  function closeMenu() {
    menuOpen = false;
    if (mobileMenu) {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
    }
    if (window.scrollY <= 50 && isTransparentPage) {
      header && header.classList.remove('site-header--scrolled');
    }
    document.body.style.overflow = '';
    if (mobileMenuBtn) {
      mobileMenuBtn.setAttribute('aria-expanded', 'false');
      mobileMenuBtn.setAttribute('aria-label', 'Menu offnen');
    }
    if (menuIconOpen) menuIconOpen.style.display = 'block';
    if (menuIconClose) menuIconClose.style.display = 'none';
    qsa('.mobile-menu-link', mobileMenu || document).forEach(function (link) {
      link.style.transitionDelay = '0ms';
    });
    /* Close all submenus when main menu closes */
    qsa('.mobile-menu-submenu-toggle').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var sub = btn.nextElementSibling;
      if (sub && sub.classList.contains('mobile-submenu')) {
        sub.classList.remove('is-open');
        sub.setAttribute('aria-hidden', 'true');
      }
    });
  }

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function () {
      menuOpen ? closeMenu() : openMenu();
    });
  }
  if (mobileMenuBackdrop) { mobileMenuBackdrop.addEventListener('click', closeMenu); }

  /* Close only plain links, not submenu toggles */
  qsa('.mobile-menu-link:not(.mobile-menu-submenu-toggle)').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });
  /* Also close when clicking submenu child links */
  qsa('.mobile-submenu-link').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  /* ── Mobile Submenu Accordion ─────────────────────────── */
  qsa('.mobile-menu-submenu-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      /* Close all other open submenus first */
      qsa('.mobile-menu-submenu-toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var s = b.nextElementSibling;
        if (s && s.classList.contains('mobile-submenu')) {
          s.classList.remove('is-open');
          s.setAttribute('aria-hidden', 'true');
        }
      });
      /* Toggle this one open if it was closed */
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        var sub = btn.nextElementSibling;
        if (sub && sub.classList.contains('mobile-submenu')) {
          sub.classList.add('is-open');
          sub.setAttribute('aria-hidden', 'false');
        }
      }
    });
  });

  /* ── Desktop Dropdown Menus ───────────────────────────── */
  qsa('.header-dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      qsa('.header-dropdown-toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });
  document.addEventListener('click', function () {
    qsa('.header-dropdown-toggle').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── Hero Carousel ────────────────────────────────────── */
  var heroCarousel = qs('.hero-carousel');
  if (heroCarousel) {
    var slides = qsa('.hero-slide', heroCarousel);
    var indicators = qsa('.hero-indicator', heroCarousel);
    var fills = qsa('.hero-indicator-fill', heroCarousel);
    var labelEl = qs('#hero-label', heroCarousel);
    var labelsData = JSON.parse(heroCarousel.dataset.labels || '[]');
    var linksData = JSON.parse(heroCarousel.dataset.links || '[]');
    var currentSlide = 0;
    var transitioning = false;
    var autoTimer = null;

    function goToSlide(index) {
      if (transitioning || index === currentSlide) return;
      transitioning = true;
      slides[currentSlide].classList.remove('is-active');
      indicators[currentSlide] && indicators[currentSlide].setAttribute('aria-selected', 'false');
      fills[currentSlide] && fills[currentSlide].classList.remove('is-active');
      currentSlide = index;
      slides[currentSlide].classList.add('is-active');
      indicators[currentSlide] && indicators[currentSlide].setAttribute('aria-selected', 'true');
      if (labelEl && labelsData[currentSlide]) {
        labelEl.textContent = labelsData[currentSlide];
        labelEl.href = linksData[currentSlide] || '#';
      }
      fills.forEach(function (f, i) {
        f.classList.remove('is-active');
        if (i < currentSlide) f.style.width = '100%';
        else if (i > currentSlide) f.style.width = '0';
      });
      setTimeout(function () {
        fills[currentSlide] && fills[currentSlide].classList.add('is-active');
        transitioning = false;
      }, 50);
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () {
        goToSlide((currentSlide + 1) % slides.length);
      }, 6000);
    }

    function stopAuto() { clearInterval(autoTimer); }

    indicators.forEach(function (btn, i) {
      btn.addEventListener('click', function () { stopAuto(); goToSlide(i); startAuto(); });
    });

    if (slides.length > 1) {
      if (fills[0]) fills[0].classList.add('is-active');
      startAuto();
    }
  }

  /* ── Cart Store ────────────────────────────────────────── */
  var cartOverlay = qs('#cart-overlay');
  var cartDrawer = qs('#cart-drawer');
  var cartCountEls = qsa('.cart-count');
  var cartBody = qs('.cart-drawer-body', cartDrawer || document);
  var cartFooter = qs('.cart-drawer-footer', cartDrawer || document);
  var cartSubtotal = qs('.cart-subtotal-value', cartDrawer || document);

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartItems(cart) {
    if (!cartBody) return;
    if (cart.items.length === 0) {
      cartBody.innerHTML = '<p class="cart-empty">Ihr Warenkorb ist leer.</p>';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }
    var html = '<div class="cart-items">';
    cart.items.forEach(function (item) {
      var price = formatMoney(item.final_line_price);
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '';
      var imgHtml = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url.replace('http://', 'https://') + '" alt="' + (item.title || '') + '" loading="lazy">'
        : '';
      html += '<div class="cart-item" data-key="' + item.key + '">';
      html += '<div class="cart-item-img">' + imgHtml + '</div>';
      html += '<div class="cart-item-info">';
      html += '<p class="cart-item-name">' + item.product_title + '</p>';
      html += variantTitle;
      html += '<div class="cart-item-qty">';
      html += '<button class="cart-qty-btn" data-action="dec" data-key="' + item.key + '" aria-label="Weniger"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
      html += '<span class="cart-qty-val">' + item.quantity + '</span>';
      html += '<button class="cart-qty-btn" data-action="inc" data-key="' + item.key + '" aria-label="Mehr"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
      html += '<button class="cart-item-remove" data-key="' + item.key + '">remove</button>';
      html += '</div></div>';
      html += '<div class="cart-item-price">' + price + '</div>';
      html += '</div>';
    });
    html += '</div>';
    cartBody.innerHTML = html;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartFooter) cartFooter.style.display = 'block';
    bindCartItemEvents();
  }

  function bindCartItemEvents() {
    if (!cartDrawer) return;
    qsa('.cart-qty-btn', cartDrawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qtyEl = btn.parentNode.querySelector('.cart-qty-val');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
        var newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
        updateCartItem(key, newQty);
      });
    });
    qsa('.cart-item-remove', cartDrawer).forEach(function (btn) {
      btn.addEventListener('click', function () { updateCartItem(btn.dataset.key, 0); });
    });
    var checkoutBtn = qs('.cart-checkout-btn', cartDrawer);
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var form = document.createElement('form');
        form.method = 'POST';
        form.action = '/checkout';
        document.body.appendChild(form);
        form.submit();
      });
    }
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); renderCartItems(cart); })
      .catch(function () {});
  }

  function updateCartItem(key, qty) {
    var body = JSON.stringify({ id: key, quantity: qty });
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); renderCartItems(cart); })
      .catch(function () {});
  }

  function addToCart(variantId, quantity, properties) {
    var body = JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties || {} });
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); });
  }

  qsa('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', openCart); });
  qsa('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCart); });
  if (cartOverlay) { cartOverlay.addEventListener('click', closeCart); }
  fetchCart();

  /* ── Search Overlay ───────────────────────────────────── */
  var searchOverlayEl = qs('#search-overlay');
  var searchInput = qs('.search-overlay-input', searchOverlayEl || document);
  var searchResultsEl = qs('.search-results', searchOverlayEl || document);

  function openSearch() {
    if (!searchOverlayEl) return;
    searchOverlayEl.classList.add('is-open');
    searchOverlayEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { searchInput && searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchOverlayEl) return;
    searchOverlayEl.classList.remove('is-open');
    searchOverlayEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResultsEl) searchResultsEl.innerHTML = '';
  }

  qsa('[data-search-open]').forEach(function (btn) { btn.addEventListener('click', openSearch); });
  qsa('[data-search-close]').forEach(function (btn) { btn.addEventListener('click', closeSearch); });

  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (!q) { if (searchResultsEl) searchResultsEl.innerHTML = ''; return; }
      searchTimer = setTimeout(function () { doSearch(q); }, 300);
    });
  }

  function doSearch(q) {
    if (!searchResultsEl) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          searchResultsEl.innerHTML = '<p class="search-no-results">Keine Ergebnisse fur &ldquo;' + q + '&rdquo;</p>';
          return;
        }
        var html = '';
        products.forEach(function (p) {
          var price = formatMoney(p.price);
          var cmpPrice = p.compare_at_price_min > p.price
            ? '<span class="price--compare">' + formatMoney(p.compare_at_price_min) + '</span> ' : '';
          html += '<a href="' + p.url + '" class="search-result-item" data-close-search>';
          html += '<div><p class="search-result-name">' + p.title + '</p>';
          html += '<p class="search-result-category">' + (p.product_type || '') + '</p></div>';
          html += '<div class="search-result-price">' + cmpPrice + price + '</div>';
          html += '</a>';
        });
        searchResultsEl.innerHTML = html;
        qsa('[data-close-search]', searchResultsEl).forEach(function (el) {
          el.addEventListener('click', closeSearch);
        });
      })
      .catch(function () {});
  }

  /* ── Product Page ──────────────────────────────────────── */
  var productForm = qs('.product-form') || qs('.sp-form');
  if (productForm) {
    var variantIdInput = productForm.querySelector('input[name="id"]');
    var atcBtn = productForm.querySelector('.atc-btn') || productForm.querySelector('.sp-atc-btn');
    var productPriceBlock = qs('#product-price');
    var productVariants = window.__productVariants || [];

    var selectedOptions = {};
    qsa('.variant-option-group, .sp-variant-option-group', productForm).forEach(function (grp) {
      var name = grp.dataset.name || grp.dataset.optionName;
      var active = grp.querySelector('.is-active');
      if (active) selectedOptions[name] = active.dataset.value;
    });

    function findVariant() {
      return productVariants.find(function (v) {
        return qsa('.variant-option-group, .sp-variant-option-group', productForm).every(function (grp, i) {
          var optKey = 'option' + (i + 1);
          return v[optKey] === selectedOptions[grp.dataset.name || grp.dataset.optionName];
        });
      });
    }

    function updateVariantDisplay(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (productPriceBlock) {
        var priceHtml = '<div class="product-price-row">';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml += '<s class="product-price--compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceHtml += '<span class="product-price">' + formatMoney(variant.price) + '</span>';
        priceHtml += '</div><p class="product-price-note">Preise inkl. Steuern und Zoll</p>';
        productPriceBlock.innerHTML = priceHtml;
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to cart' : 'AUSVERKAUFT';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    qsa('.variant-opt-btn, .sp-variant-opt-btn', productForm).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grp = btn.closest('.variant-option-group, .sp-variant-option-group');
        if (!grp) return;
        var name = grp.dataset.name || grp.dataset.optionName;
        qsa('.variant-opt-btn, .sp-variant-opt-btn', grp).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedOptions[name] = btn.dataset.value;
        var valEl = grp.querySelector('.variant-value');
        if (valEl) valEl.textContent = btn.dataset.value;
        var variant = findVariant();
        updateVariantDisplay(variant);
      });
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = findVariant();
      if (!variant || !variant.available) return;
      atcBtn.textContent = '...';
      atcBtn.classList.add('is-loading');
      addToCart(variant.id, 1).then(function () {
        atcBtn.textContent = 'IN DEN WARENKORB';
        atcBtn.classList.remove('is-loading');
        openCart();
      }).catch(function () {
        atcBtn.textContent = 'FEHLER';
        atcBtn.classList.remove('is-loading');
        setTimeout(function () { atcBtn.textContent = 'IN DEN WARENKORB'; }, 2000);
      });
    });
  }

  /* ── Product Tabs ──────────────────────────────────────── */
  qsa('.product-tab-btn, .sp-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.dataset.panel || btn.dataset.tab;
      var panel = qs('#' + panelId);
      if (!panel) return;
      var tabGroup = btn.closest('.product-tabs, .sp-tabs');
      if (tabGroup) {
        qsa('.product-tab-btn, .sp-tab-btn', tabGroup).forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        qsa('.product-tab-panel, .sp-tab-panel', tabGroup).forEach(function (p) {
          p.classList.remove('is-active');
        });
      }
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      panel.classList.add('is-active');
    });
  });

  /* ── Product Gallery Tabs (mobile) ────────────────────── */
  qsa('.gallery-tab').forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      qsa('.gallery-tab').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var slide = qs('#gallery-slide-mobile-' + i);
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    });
  });

  /* ── Temperature Range toggle ─────────────────────────── */
  var tempRange = qs('.temp-range');
  if (tempRange) {
    var tempMin = parseFloat(tempRange.dataset.min);
    var tempMax = parseFloat(tempRange.dataset.max);
    var scaleMin = -20, scaleRange = 60;
    var tempFill = qs('.temp-fill', tempRange);
    var tempDots = qsa('.temp-dot', tempRange);
    var tempLabels = qs('.temp-labels', tempRange);

    function renderTempLabels(unit) {
      if (!tempLabels) return;
      var lo = unit === 'F' ? Math.round(tempMin * 9 / 5 + 32) : tempMin;
      var hi = unit === 'F' ? Math.round(tempMax * 9 / 5 + 32) : tempMax;
      tempLabels.innerHTML = '<span>' + lo + '&deg;' + unit + '</span><span>' + hi + '&deg;' + unit + '</span>';
    }

    var fillLeft = ((tempMin - scaleMin) / scaleRange) * 100;
    var fillW = ((tempMax - tempMin) / scaleRange) * 100;
    if (tempFill) { tempFill.style.left = fillLeft + '%'; tempFill.style.width = fillW + '%'; }
    if (tempDots[0]) tempDots[0].style.left = fillLeft + '%';
    if (tempDots[1]) tempDots[1].style.left = (fillLeft + fillW) + '%';
    renderTempLabels('C');

    qsa('.temp-unit-btn', tempRange).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('.temp-unit-btn', tempRange).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        renderTempLabels(btn.dataset.unit);
      });
    });
  }

  /* ── USP Modal ─────────────────────────────────────────── */
  var uspModal = qs('#usp-modal');
  if (uspModal) {
    var uspBadge = qs('.usp-modal-badge', uspModal);
    var uspDesc = qs('.usp-modal-desc', uspModal);
    var uspTags = qsa('.usp-modal-tag', uspModal);
    var uspBg = qs('.usp-modal-bg', uspModal);
    var uspClose = qs('.usp-modal-close', uspModal);

    function openUsp(label, desc) {
      if (uspBadge) uspBadge.textContent = label;
      if (uspDesc) uspDesc.textContent = desc;
      uspTags.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.label === label);
      });
      uspModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeUsp() {
      uspModal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    qsa('.product-usp-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { openUsp(btn.dataset.label, btn.dataset.desc); });
    });
    uspTags.forEach(function (t) {
      t.addEventListener('click', function () { openUsp(t.dataset.label, t.dataset.desc); });
    });
    if (uspBg) uspBg.addEventListener('click', closeUsp);
    if (uspClose) uspClose.addEventListener('click', closeUsp);
  }

  /* ── Collection Sort ───────────────────────────────────── */
  var sortSelect = qs('.sort-select');
  if (sortSelect) {
    var sortUrl = new URL(window.location.href);
    var sortVal = sortUrl.searchParams.get('sort_by');
    if (sortVal) sortSelect.value = sortVal;
    sortSelect.addEventListener('change', function () {
      var newUrl = new URL(window.location.href);
      newUrl.searchParams.set('sort_by', sortSelect.value);
      window.location.href = newUrl.toString();
    });
  }

  /* ── Newsletter Form ───────────────────────────────────── */
  var newsletterForm = qs('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      var input = newsletterForm.querySelector('.newsletter-input');
      if (input && !input.value.includes('@')) {
        e.preventDefault();
        input.focus();
        showToast('Bitte gultige E-Mail-Adresse eingeben.');
      }
    });
  }

  /* ── Keyboard accessibility ────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchOverlayEl && searchOverlayEl.classList.contains('is-open')) { closeSearch(); return; }
      if (uspModal && uspModal.classList.contains('is-open')) { closeUsp && closeUsp(); return; }
      if (cartDrawer && cartDrawer.classList.contains('is-open')) { closeCart(); return; }
      if (menuOpen) { closeMenu(); }
    }
  });

  /* ── Lazy loading polyfill ─────────────────────────────── */
  if (!('loading' in HTMLImageElement.prototype)) {
    var lazyImages = qsa('img[loading="lazy"]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            img.src = img.dataset.src || img.src;
            io.unobserve(img);
          }
        });
      });
      lazyImages.forEach(function (img) { io.observe(img); });
    }
  }

})();